// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={187}
      height={34}
      viewBox="0 0 187 34"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#99D6EB"
          fillRule="nonzero"
          d="M94 21.03c0 3.69 1.74 5.601 5.365 5.601a9.814 9.814 0 0 0 6.07-2.032l.264 1.659h2.677V0l-3.172.45v7.688a29.491 29.491 0 0 0-5.244-.56c-4.308 0-5.96 2.328-5.96 5.985v7.49-.023Zm11.204.637a8.507 8.507 0 0 1-5.211 2.197c-2.203 0-2.831-.945-2.831-2.823v-7.5c0-2.197.87-3.196 2.985-3.196 1.699.041 3.39.229 5.057.56v10.762Zm12.382 4.59V7.93h-3.173v18.329h3.173Zm0-21.25V.45h-3.173v4.547l3.173.01Zm20.26 2.933h-5.289a12.021 12.021 0 0 0-3.095-.373c-5.244 0-7.172 2.295-7.172 6.281v.824c0 2.405.826 4.217 2.567 5.194a4.126 4.126 0 0 0-1.74 3.24c0 1.691.87 3.119 3.58 3.295 2.203.186 2.83.263 4.869.45 2.038.186 2.72.45 2.72 1.998 0 1.922-.45 2.56-5.133 2.56a29.225 29.225 0 0 1-6.147-.758l-.452 2.481c2.185.542 4.425.834 6.676.868 6.61 0 8.042-1.318 8.042-5.304 0-2.779-1.289-4.064-4.605-4.393l-5.21-.527c-.827-.077-1.212-.34-1.212-1.098a2.855 2.855 0 0 1 1.322-1.955c.625.077 1.254.114 1.884.11 4.792 0 7.204-2.296 7.204-6.249v-.824a6.497 6.497 0 0 0-1.013-3.646l2.203-.417V7.929v.01Zm-4.187 5.941v.79c0 2.406-1.168 3.647-4.186 3.647-3.019 0-4.187-.868-4.187-3.646v-.79c0-2.713 1.102-3.724 4.187-3.724 3.084 0 4.186 1.098 4.186 3.723Zm11.622 12.377V7.928h-3.173v18.33h3.173Zm0-21.25V.45h-3.173v4.547l3.173.01Zm15.203 18.504c-.957.275-1.946.426-2.942.45-1.696 0-1.884-.68-1.884-2.031V10.565h4.947l.264-2.636h-5.21V2.965l-3.173.45V7.93h-3.25v2.636h3.25v11.893c0 3.042 1.476 4.173 4.56 4.173a11.467 11.467 0 0 0 3.845-.68l-.418-2.45.01.011Zm17.769-10.004c0-3.91-1.74-5.941-6.984-5.941a25.998 25.998 0 0 0-6.037.79l.341 2.526a30.486 30.486 0 0 1 5.508-.604c2.986 0 4 .79 4 3.086v2.855h-4.903c-3.701 0-5.618 1.351-5.618 5.15 0 3.24 1.432 5.272 4.869 5.272a10.49 10.49 0 0 0 5.96-1.735l.187 1.35h2.677v-12.76.01Zm-3.173 8.917a9.207 9.207 0 0 1-4.77 1.549c-2.258 0-2.6-.758-2.6-2.636 0-1.878.716-2.45 2.677-2.45h4.682v3.57l.011-.033ZM187 26.258V0l-3.173.45v25.808H187Z"
        />
        <path
          fill="#09C"
          d="M9.968 12.925 9.526 8a17.2 17.2 0 0 0-4.785 2.062l-.366-1.699H0V26h5.29V15.21A25.835 25.835 0 0 1 10 12.894l-.032.032zM29 26V13.44c0-3.466-1.103-5.748-4.19-5.748-2.264.094-4.481.661-6.506 1.663V0L13 .739V26h5.381V14.179a11.516 11.516 0 0 1 3.926-1.326c.366-.078.749.032 1.014.294.266.261.378.638.298 1V26H29zM39 6V1h-5v5h5zM39 26V8h-5v18h5z"
        />
        <path
          fill="#09C"
          fillRule="nonzero"
          d="M58.957 19.617v-4.234c0-3.747-1.705-7.383-8-7.383S43 11.636 43 15.383v4.234C43 23.364 44.705 27 51 27s8-3.636 8-7.383h-.043Zm-5.233.143c0 1.725-.869 2.697-2.767 2.697s-2.767-.972-2.767-2.697V15.23c0-1.725.869-2.697 2.767-2.697s2.767.972 2.767 2.697v4.531Z"
        />
        <path
          fill="#09C"
          d="M79 26V13.651C79 10.243 77.897 8 74.81 8c-2.513.08-4.983.658-7.256 1.699l-.562-1.336H63V26h5.381V14.335a10.777 10.777 0 0 1 3.926-1.26c.366-.078.749.03 1.014.288.266.257.378.627.298.982V26H79ZM89 26v-5h-5v5h5z"
        />
      </g>
    </svg>
  );
};

const RhionIcon = Icon;
export default RhionIcon;
